import { lazy } from "react";
import { warehouseSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "stores" */ './components/EntryPoint'));
const StoresLoader = lazy(() => import(/* webpackChunkName: "storesLoader" */ './components/StoresLoader'));
const FormStore = lazy(() => import(/* webpackChunkName: "formStore" */ './components/FormStore'));

export const defaultPath = '/stores';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: StoresLoader,
        exact: true,
        icon: warehouseSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'stores_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: FormStore,
        exact: true,
        icon: warehouseSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'Crear bodegas',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: FormStore,
        exact: true,
        icon: warehouseSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'modify_store',
            plural: false
        }
    }
];

const Stores = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: warehouseSVG,
    title: {
        key: 'Bodegas',
        plural: false
    },
    subTitle: {
        key: '',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Stores;
